import { Grid, SegmentedControl, Text } from '@mantine/core';
import LabeledSlider from '../LabeledSlider';

const AbTestConfiguration = ({ abTest, setAbTest, readOnly = false }) => {
  // The details page renders the panel purely to show what the test was started
  // with — it has no save action and passes no setAbTest, so its controls must
  // never be interactive.
  const disabled = !!(readOnly || abTest.running || abTest.periodEnd);

  const handleChange = (event) => {
    setAbTest({ ...abTest, [event.target.name]: event.target.value });
  };

  const controlGroupSelector = (
    <Grid align="center" mb="sm">
      <Grid.Col span={{ base: 12, sm: 4 }}>
        <Text fw={500}>Control Group Fraction</Text>
      </Grid.Col>
      <Grid.Col span={{ base: 12, sm: 8 }}>
        <LabeledSlider
          disabled={disabled}
          min={0}
          max={10000}
          step={1000}
          value={abTest.controlGroupFraction}
          onChange={(fraction) => handleChange({ target: { name: 'controlGroupFraction', value: fraction } })}
        />
        <Text size="sm" c="dimmed" mt="xl">
          <>
            <b>Info: </b>This setting separates how much in <b>%</b> will users will be split into groups&nbsp;
            <b>Control/Treatment.</b>
          </>
          <br />
          <>
            <b>Example: </b>If you set on <b>60%</b> - 1000 interactions will be split into:&nbsp;
            <b>600 Control | 400 Treatment</b>
          </>
          <br />
          <>
            <b>Example: </b>If you set on <b>10%</b> - 1000 interactions will be split into:&nbsp;
            <b>100 Control | 900 Treatment</b>
          </>
        </Text>
      </Grid.Col>
    </Grid>
  );

  const hypothesisSelector = (
    <Grid align="center" mb="sm">
      <Grid.Col span={{ base: 12, sm: 4 }}>
        <Text fw={500}>Hypothesis</Text>
      </Grid.Col>
      <Grid.Col span={{ base: 12, sm: 8 }}>
        <SegmentedControl
          disabled={disabled}
          value={abTest.hypothesis ?? ''}
          onChange={(hypothesis) => handleChange({ target: { name: 'hypothesis', value: hypothesis } })}
          data={[
            { label: 'One sided', value: 'oneSided' },
            { label: 'Two sided', value: 'twoSided' },
          ]}
        />
        <Text size="sm" c="dimmed" mt="xs">
          <>
            <b>One sided: </b> If you expect the effect in <b>one</b> direction only — it asks whether Releva does
            better than the control.
          </>
          <br />
          <>
            <b>Two sided: </b> If you expect a difference in <b>either</b> direction — it asks whether Releva does
            better or worse than the control.
          </>
        </Text>
      </Grid.Col>
    </Grid>
  );

  const configuration = (
    <>
      {controlGroupSelector}
      {hypothesisSelector}
    </>
  );

  return configuration;
};

export default AbTestConfiguration;
